import api from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5003/api';

const callSettingsService = {
  // Get all countries
  getCountries: async () => {
    try {
      const response = await api.get(`${API_BASE_URL}/call-settings/countries`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get call settings for an organization
  getCallSettings: async (organizationId) => {
    try {
      const response = await api.get(
        `${API_BASE_URL}/call-settings/organization/${organizationId}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Create or update call settings
  saveCallSettings: async (organizationId, data) => {
    try {
      const response = await api.post(
        `${API_BASE_URL}/call-settings/organization/${organizationId}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Add Plivo country configuration
  addPlivoCountry: async (organizationId, countryData) => {
    try {
      const response = await api.post(
        `${API_BASE_URL}/call-settings/organization/${organizationId}/plivo/country`,
        countryData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Remove Plivo country configuration
  removePlivoCountry: async (organizationId, countryId) => {
    try {
      const response = await api.delete(
        `${API_BASE_URL}/call-settings/organization/${organizationId}/plivo/country/${countryId}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Add Twilio country configuration
  addTwilioCountry: async (organizationId, countryData) => {
    try {
      const response = await api.post(
        `${API_BASE_URL}/call-settings/organization/${organizationId}/twilio/country`,
        countryData
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Remove Twilio country configuration
  removeTwilioCountry: async (organizationId, countryId) => {
    try {
      const response = await api.delete(
        `${API_BASE_URL}/call-settings/organization/${organizationId}/twilio/country/${countryId}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export { callSettingsService };
